import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useQuasar } from 'quasar';

// Personal libs
import { $t } from '@i18n/utils';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * Globals
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'QOfflineBanner',
  setup(__props) {

// Vendor
const $q = useQuasar();

/**
 * Computed properties
 */
const isOnline = computed(() => sessionManager.isOnline.value === true);
const hasToDisplayMessage = computed<boolean>(
  () => !isOnline.value,
);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      appear: "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_banner, {
          rounded: "",
          class: _normalizeClass([
          'bg-orange text-black q-mb-md shadow-3 z-index-foreground fixed-bottom max-width',
          {
            'q-mx-auto': !_unref($q).platform.is.mobile,
            'q-mx-md': _unref($q).platform.is.mobile,
          },
        ])
        }, {
          avatar: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "warning",
              color: "black"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_unref($t)('generic.hasToBeOnline')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class"]), [
          [_vShow, hasToDisplayMessage.value]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})